import React from "react";

import Editor from './ABridTileSmallEditor'
import EditorWrapper from '../../EditorWrapper'

import BridTileSmall1 from "../../common/BridTileSmall1";
import { BridTileArticle } from "../../common/EmptyArticle";

const ATextOnPicture = props => {
    let article = BridTileArticle();
    const { settings } = props;
    const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

    article.title = settings.title_normal;
    article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
    article.url = settings.link;
    article.label = settings.label;
    article.articleID = settings.articleID;

    // linki dodatkowe
    settings.show_links = (settings.show_links ? settings.show_links : 'off');
    article.show_links = settings.show_links;
    article.links = settings.links;

    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridTileSmall1
                article={article}
                size={props.size}
                imageHeight={props.imageHeight}
                preserveImageRatio={props.preserveImageRatio}
                secondArticleID={props.secondArticleID}
                thirdArticleID={props.thirdArticleID}
                {...props}
            />
        </div>
    );
};

export default ATextOnPicture;
